import { Component, signal } from '@angular/core';

@Component({
  selector: 'ctr-footer',
  imports: [],
  template: `
    <div class="bg-white shadow">
      <div class="mx-auto px-10" [style.max-width]="maxSize()">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  maxSize = signal('');

  setMaxSize(typePage: 'page' | 'form') {
    this.maxSize.set(typePage === 'page' ? '1280px' : '980px');
  }
}
